module.exports = __webpack_public_path__ + "static/media/blog-img.c666bae2.png";